var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualPartsBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56167 6.7017C11.1353 6.7017 12.4125 5.42452 12.4125 3.85085C12.4125 2.27718 11.1353 1 9.56167 1C7.988 1 6.71082 2.27718 6.71082 3.85085C6.71082 5.42452 7.988 6.7017 9.56167 6.7017ZM12.6691 9.89465C12.4467 9.66658 12.1673 9.55255 11.8424 9.55255H7.85116L6.66521 9.13632L6.85336 8.60037L7.85116 8.98238H9.44764C9.6472 8.98238 9.80684 8.90256 9.93798 8.77142C10.0691 8.64028 10.1318 8.48063 10.1318 8.30388C10.1318 7.99599 9.9836 7.78502 9.68711 7.66529L5.54197 6.13153H4.43014V11.2631L8.42133 12.4034L12.9998 10.6929C13.0055 10.3907 12.8915 10.1227 12.6691 9.89465ZM3.2898 6.13153H1V12.4034H3.2898V6.13153Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualPartsBudget);
export default __webpack_public_path__ + "static/media/manual-parts-budget.a7a3d619a8a29e2efec5f62f3fdd8c5f.svg";
export { ForwardRef as ReactComponent };